export default __webpack_public_path__ + "static/accents-colors-light-7148107094f8306f4a7ecb23f52da461da781a6f057af8a673af56504f6f8f99.png";